<template>
  <v-container fluid>
    <div v-if="isCliente == 0">
    <section class="content-header">
      <v-toolbar dark dense color="#96298A">
        <v-toolbar-title>Usuarios</v-toolbar-title>
        <v-divider class="mx-4" vertical />
        <v-text-field
          v-model="searcher"
          label="Buscar"
          single-line
          hide-details
          clearable
          max-width="200px"
          @keyup.enter="fillUsuarios()"
          @input="handleChangeSearch()"
        ></v-text-field>
        <v-tooltip bottom color="#96298A">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              ref="getData"
              icon
              @click="fillUsuarios()"
              x-large
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-file-find </v-icon>
            </v-btn>
          </template>
          <span>Buscar</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-divider class="mx-4" vertical />
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="fillCbxShowModal()"
                x-large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-database-plus</v-icon>
              </v-btn>
            </template>
            <span>Crear Nuevo</span>
          </v-tooltip>
          <v-divider class="mx-4" vertical />
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="fillUsuarios()"
                x-large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-table-refresh</v-icon>
              </v-btn>
            </template>
            <span>Actualizar Tabla</span>
          </v-tooltip>
        </v-toolbar-items>
      </v-toolbar>
    </section>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="usuarios"
          :search="searcher"
          class="elevation-1"
          :options.sync="options"
          :server-items-length="totalData"
        >
          <template v-slot:item.acciones="{ item }">
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="info"
                  @click="fillCbxShowModal(true, item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="red"
                  @click="deleteItem(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
          <template v-slot:item.cliente="{ item }">
            <v-icon v-if="item.cliente" color="green">mdi-check</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!--FORMULARIO MODAL -->
    <v-dialog
      v-model="dialog"
      :fullscreen="fullScreen"
      transition="dialog-bottom-transition"
      persistent
      width="800"
    >
      <v-card elevation="24" outlined>
        <v-toolbar dark dense color="#96298A">
          <v-toolbar-title>Usuario - {{ camposBD.name }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-divider vertical />
            <v-btn v-if="!fullScreen" icon dark @click="fullScreen = true">
              <v-icon>mdi-window-maximize</v-icon>
            </v-btn>
            <v-btn v-if="fullScreen" icon dark @click="fullScreen = false">
              <v-icon>mdi-window-minimize</v-icon>
            </v-btn>
            <v-divider vertical />
            <v-btn icon dark @click="closeAndResetCbx()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-divider vertical />
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-tabs v-model="tab">
              <v-tab ripple href="#tab-1">
                <v-icon>mdi-account-box</v-icon>- Usuario
              </v-tab>
              <v-tab v-if="camposBD.cliente" ripple href="#tab-2">
                <v-icon>mdi-account-supervisor-circle-outline</v-icon>-
                Información de Cliente
              </v-tab>
              <v-tab ripple href="#tab-3">
                <v-icon>mdi-cash-lock-open</v-icon>-
                Tarifas
              </v-tab>
              <v-tab-item value="tab-1">
                  <v-row>
                      <v-col>
                          <v-text-field
                            label="Nombre"
                            v-model="camposBD.name"
                            ref="nombre"
                            :rules="[reglas.requeridoTxt, reglas.largo(60)]"
                            required
                            :counter="60"
                            append-icon="mdi-account"
                            ></v-text-field>
                      </v-col>
                  </v-row>
                  <v-row>
                      <v-col>
                          <v-text-field
                            label="Email"
                            v-model="camposBD.email"
                            ref="email"
                            :rules="[reglas.requeridoTxt, reglas.largo(50)]"
                            required
                            :counter="50"
                            append-icon="mdi-email"
                            ></v-text-field>
                      </v-col>
                  </v-row>
                  <v-row>
                      <v-col>
                          <v-text-field
                            label="Clave"
                            v-model="camposBD.password"
                            ref="password"
                            :rules="!this.modalEditando ? [reglas.requeridoTxt, reglas.largo(40)] : [reglas.largo(40)]"
                            required
                            :counter="40"
                            persistent-hint
                            :hint="hintPwd"
                            type="password"
                            append-icon="mdi-lock"
                            ></v-text-field>
                      </v-col>
                  </v-row>
                  <v-row>
                      <v-col>
                          <v-checkbox
                            label="Cliente"
                            v-model="camposBD.cliente"
                            @change="handleChangeCliente()"
                            ></v-checkbox>
                      </v-col>
                  </v-row>
              </v-tab-item>
              <v-tab-item value="tab-2" v-if="camposBD.cliente">
                <v-row>
                  <v-col cols="12" sm="12" md="8">
                    <v-text-field
                      label="Código"
                      v-model="camposBD.codigo"
                      ref="codigo"
                      :rules="[reglas.requeridoTxt, reglas.largo(30)]"
                      required
                      :counter="30"
                      append-icon="mdi-card-text"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="Nombre de la Empresa"
                      v-model="camposBD.empresa"
                      ref="empresa"
                      :rules="[reglas.requeridoTxt, reglas.largo(60)]"
                      required
                      :counter="60"
                      append-icon="domain"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="Contacto"
                      v-model="camposBD.contacto"
                      ref="contacto"
                      :rules="[reglas.requeridoTxt, reglas.largo(35)]"
                      required
                      :counter="35"
                      append-icon="person"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="Telefono"
                      v-model="camposBD.telefono"
                      ref="telefono"
                      :rules="[reglas.requeridoTxt, reglas.largo(25)]"
                      required
                      :counter="25"
                      append-icon="settings_phone"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="NIT/RUC"
                      v-model="camposBD.nit"
                      ref="nit"
                      :rules="[reglas.largo(30)]"
                      :counter="30"
                      append-icon="card_travel"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="8">
                    <v-text-field
                      label="Direccion 1"
                      v-model="camposBD.direccion1"
                      ref="direccion1"
                      append-icon="assistant_direction"
                      :rules="[reglas.requeridoTxt, reglas.largo(45)]"
                      required
                      :counter="45"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Direccion 2"
                      v-model="camposBD.direccion2"
                      ref="direccion2"
                      :rules="[reglas.requeridoTxt, reglas.largo(45)]"
                      :counter="45"
                      required
                      append-icon="assistant_direction"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Direccion 3"
                      v-model="camposBD.direccion3"
                      :rules="[reglas.largo(45)]"
                      :counter="45"
                      ref="direccion3"
                      append-icon="assistant_direction"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-combobox
                      v-model="pais"
                      :items="paises"
                      item-text="nombre"
                      item-value="iso"
                      label="Pais"
                      :rules="[reglas.requeridoCbx]"
                      required
                      append-icon="map"
                      return-object
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-combobox
                      v-model="estado"
                      :items="estados"
                      item-text="nombre"
                      item-value="abbr"
                      label="Estado"
                      :rules="[reglas.requeridoCbx]"
                      required
                      append-icon="pin_drop"
                      return-object
                      v-if="camposBD.pais == 'US'"
                    ></v-combobox>
                    <v-text-field
                      label="Estado / Departamento"
                      v-model="camposBD.estado"
                      ref="estado"
                      :rules="[reglas.largo(35)]"
                      :counter="35"
                      v-if="camposBD.pais != 'US' && camposBD.pais != 'EC'"
                      append-icon="pin_drop"
                    ></v-text-field>
                    <v-combobox
                      v-model="provincia"
                      :items="provincias"
                      item-text="provincia"
                      item-value="provincia"
                      label="Provincia"
                      :rules="[reglas.requeridoCbx]"
                      required
                      append-icon="pin_drop"
                      return-object
                      v-if="camposBD.pais == 'EC'"
                    ></v-combobox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-combobox
                      v-model="ciudad"
                      :items="ciudades"
                      item-text="ciudad"
                      item-value="ciudad"
                      label="Ciudad"
                      :rules="[reglas.requeridoCbx]"
                      required
                      append-icon="pin_drop"
                      return-object
                      v-if="camposBD.pais == 'EC'"
                    ></v-combobox>
                    <v-text-field
                      label="Ciudad"
                      v-model="camposBD.ciudad"
                      ref="ciudad"
                      :rules="[reglas.requeridoTxt, reglas.largo(35)]"
                      :counter="35"
                      required
                      append-icon="place"
                      v-if="camposBD.pais != 'EC'"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="ZIP"
                      v-model="camposBD.zip"
                      :rules="[reglas.largo(12)]"
                      :counter="12"
                      ref="zip"
                      append-icon="near_me"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item value="tab-3">
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-combobox
                      v-model="tarifaImport"
                      :items="tiposTarifa"
                      item-text="tipo"
                      item-value="codigo"
                      label="Tarifa Import"
                      append-icon="mdi-cash-lock"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-combobox
                      v-model="tarifaExport"
                      :items="tiposTarifa"
                      item-text="tipo"
                      item-value="codigo"
                      label="Tarifa Export"
                      append-icon="mdi-cash-lock"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-combobox
                    :disabled = "tarifaImport != null && tarifaImport.codigo == 'E'"
                      v-model="descuentoImport"
                      :items="tiposDescuento"
                      item-text="codigo"
                      item-value="id"
                      label="Descuento para Import"
                      append-icon="mdi-cash-lock"
                      return-object
                      clearable
                      persistent-hint
                      :hint="descuentoImport ? descuentoImport.porc_descuento + '%' : null"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-combobox
                      :disabled = "tarifaExport != null && tarifaExport.codigo == 'E'"
                      v-model="descuentoExport"
                      :items="tiposDescuento"
                      item-text="codigo"
                      item-value="id"
                      label="Descuento para Export"
                      append-icon="mdi-cash-lock"
                      return-object
                      clearable
                      persistent-hint
                      :hint="descuentoExport ? descuentoExport.porc_descuento + '%' : null"
                    ></v-combobox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-combobox
                      v-model="tramiteImport"
                      :items="tiposTramite"
                      item-text="tipo"
                      item-value="codigo"
                      label="Tramite Import"
                      append-icon="mdi-cash-lock"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" outlined @click="closeAndResetCbx()">
            Cancelar
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
          <v-btn color="primary darken-1" outlined @click="saveItem()">
            Guardar
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--FORMULARIO MODAL -->
    </div>
    <div v-else>
      <h1>Usted no tiene permisos para ver esta sección</h1>
    </div>
  </v-container>
</template>
<script>
import apicon from "../plugins/apicon";
export default {
  created: function () {},
  data() {
    return {
      tab: "tab-1",
      fullScreen: false,
      searcher: "",
      options: {},
      totalData: 0,
      dialog: false,
      valid: true,
      modalEditando: false,
      isCliente: 1,
      usuarios: [],
      paises: [],
      pais: null,
      estados: [],
      estado: null,
      provincias: [],
      provincia: null,
      ciudades: [],
      ciudad: null,
      headers: [
        { text: "Nombre", value: "name" },
        { text: "Email", value: "email" },
        { text: "Empresa", value: "empresa" },
        { text: "Es Cliente?", value: "cliente" },
        { text: "Pais", value: "pais" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      /*Variables*/
      camposBD: {
        id: 0,
        name: null,
        email: null,
        password: null,
        cliente: false,
        codigo: null,
        contacto: null,
        empresa: null,
        nit: null,
        telefono: null,
        direccion1: null,
        direccion2: null,
        direccion3: null,
        ciudad: null,
        provincia: null,
        estado: null,
        zip: null,
        pais: null,
        tarifa_import: null,
        tarifa_export: null,
        descuento_import_id: null,
        descuento_export_id: null,
        tramite_import: null,
      },
      hintPwd: '',
      tarifaImport: null,
      tarifaExport: null,
      tramiteImport: null,
      tiposTarifa: [
        {codigo: 'P', tipo: 'Publica'},
        {codigo: 'E', tipo: 'Especial'},
      ],
      tiposTramite: [
        {codigo: 'P', tipo: 'Publico'},
        {codigo: 'E', tipo: 'Especial'},
      ],
      descuentoImport: null,
      descuentoExport: null,
      tiposDescuento: [],
      /*Variables*/
    };
  },
  watch: {
    pais: function (item) {
      if (item) {
        this.camposBD.pais = item.iso;
        if (item.iso != "EC") {
          this.provincia = null;
          this.ciudad = null;
          this.camposBD.provincia = null;
        }
      }
    },
    estado: function (item) {
      if (item) {
        this.camposBD.estado = item.abbr;
      }
    },
    provincia: function (item) {
      if (item) {
        this.camposBD.provincia = item.provincia;
        this.ciudad = null;
        this.fillCiudadesEc(item.provincia);
      }
    },
    ciudad: function (item) {
      if (item) {
        this.camposBD.ciudad = item.ciudad;
      }
    },
    tarifaImport: function(item){
      if(item){
        this.camposBD.tarifa_import = item.codigo
        if(item.codigo == 'E'){
          this.descuentoImport = null;
        }
      }else{
        this.camposBD.tarifa_import = null
      }
    },
    tarifaExport: function(item){
      if(item){
        this.camposBD.tarifa_export = item.codigo
        if(item.codigo == 'E'){
          this.descuentoExport = null;
        }
      }else{
        this.camposBD.tarifa_export = null
      }
    },
    tramiteImport: function(item){
      if(item){
        this.camposBD.tramite_import = item.codigo
      }else{
        this.camposBD.tramite_import = null
      }
    },
    descuentoImport: function(item){
      if(item){
        this.camposBD.descuento_import_id = item.id
      }else{
        this.camposBD.descuento_import_id = null
      }
    },
    descuentoExport: function(item){
      if(item){
        this.camposBD.descuento_export_id = item.id
      }else{
        this.camposBD.descuento_export_id = null
      }
    },
    options: {
      handler() {
        this.fillUsuarios();
      },
      deep: true,
    },
  },
  methods: {
    //Obtener los datos para rellenar la tabla del index
    fillUsuarios: function () {
      const { page, itemsPerPage } = this.options;
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() +
            "usuariotbl?page=" +
            page +
            "&per_page=" +
            itemsPerPage +
            (this.searcher != null ? "&search=" + this.searcher : "")
        )
        .then((result) => {
          this.usuarios = result.data;
          this.totalData = result.total;
        });
    },
    fillTiposDescuento: async function(){
      await apicon.getDataApi(apicon.getApiBaseUrl() + 'coddescuento')
          .then((result) => {
            this.tiposDescuento = result;
          })
    },
    fillPaises: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "pais")
        .then((result) => {
          this.paises = result;
        });
    },
    fillEstados: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "estado")
        .then((result) => {
          this.estados = result;
        });
    },
    fillProvincias: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "provinciasec")
        .then((result) => {
          this.provincias = result;
        });
    },
    fillCiudadesEc: async function (provincia) {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "ciudadesec/" + provincia)
        .then((result) => {
          this.ciudades = result;
        });
    },
    //Guardar o Actualizar
    saveItem: function () {
      if (this.$refs.form.validate()) {
        //Actualizar
        if (this.modalEditando) {
          apicon
            .updateDataApi(
              apicon.getApiBaseUrl() + "usuario/" + this.camposBD.id,
              this.camposBD
            )
            .then((result) => {
              this.fillUsuarios();
              this.closeAndResetCbx();
              this.$swal(result.message);
            });
        } else {
          //Guardar
          apicon
            .saveDataApi(apicon.getApiBaseUrl() + "usuario", this.camposBD)
            .then((result) => {
              this.fillUsuarios();
              this.limpiarCampos();
              this.pais = null;
              this.$swal(result.message);
            });
        }
      }
    },
    //Eliminar
    deleteItem: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon
            .deleteDataApi(apicon.getApiBaseUrl() + "usuario/" + item.id)
            .then((result) => {
              self.fillUsuarios();
              this.$swal(result.message);
            });
        }
      });
    },
    fillCbxShowModal: async function (editando = false, item = []) {
      this.modalEditando = editando;
      await this.fillPaises();
      await this.fillEstados();
      await this.fillProvincias();
      await this.fillTiposDescuento();

      if (editando) {
          this.hintPwd = "Ingrese la clave unicamente si desea cambiar la anterior";
        await Object.keys(this.camposBD).forEach((key) => {
          this.camposBD[key] = item[key];
        });
        this.camposBD.password = null;//Dejarlo null para que el usuario decida si cambiar o no.
        this.pais = item.pais_data; //this.paises.find((pais) => pais.iso === item.pais);
        this.estado = item.estado_data;
        this.provincia = this.provincias.find(
          (pro) => pro.provincia === item.provincia
        );
        await this.fillCiudadesEc(
          this.provincia != null ? this.provincia.provincia : 0
        );
        this.ciudad = this.ciudades.find((ciu) => ciu.ciudad === item.ciudad);
        this.tarifaImport = this.tiposTarifa.find((tt) => tt.codigo == item.tarifa_import);
        this.tarifaExport = this.tiposTarifa.find((tt) => tt.codigo == item.tarifa_export);
        this.descuentoImport = this.tiposDescuento.find((td) => td.id == item.descuento_import_id);
        this.descuentoExport = this.tiposDescuento.find((td) => td.id == item.descuento_export_id);
      } else {
          this.hintPwd = "";
        this.limpiarCampos();
      }
      this.dialog = true;
    },
    limpiarCampos: function () {
      Object.keys(this.camposBD).forEach((key) => {
        this.camposBD[key] = null;
      });
      this.camposBD.cliente = false; //Esto porque default no es null.
      this.pais = null;
      this.estado = null;
      this.provincia = null;
      this.ciudad = null;
      this.tarifaImport = null;
      this.tarifaExport = null;
      this.descuentoImport = null;
      this.descuentoExport = null;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.tab ="tab-1";
    },
    closeAndResetCbx: function () {
      this.limpiarCampos();
      this.dialog = false;
    },
    handleChangeSearch: function () {
      if (this.searcher == null || this.searcher == "") {
        this.fillUsuarios();
      }
    },
    handleChangeCliente: function() {
        if (this.$refs.form) {
            this.$refs.form.resetValidation();
        }
    },
  },
  mounted() {
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>
